import * as api from "./api";

interface FeatureTogglesResponse {
	result: FeatureToggles;
}

export interface FeatureToggles {
	"classwize-teacher-student-chat": boolean;
	"connection-search-report": boolean;
	"hide-courses-tab": boolean;
	"show-manage-user-password": boolean;
	"shr-enabled": boolean;
	global_rules_validation_enabled: boolean;
	rules_validation_enabled: boolean;
	"show-courses-tab": boolean;
}

export const getFeatureToggles = async (options = {}): Promise<FeatureToggles> => {
	const res = (await api.get("/backend/config/feature-flags", options)) as FeatureTogglesResponse;
	return res.result;
};
